import React, { Component, Fragment, useState, useEffect } from "react";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { getUserFaq } from "../../Features/SiteSettings/siteSettingSlice";
import { useDispatch } from "react-redux";
import { useTranslation, I18nextProvider } from "react-i18next";



import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";


import { useCustomizeContext } from "../../context";

const Faq = (props) => {
    let dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const {
        sideMenu: {
            classIsActive, setClassIsActive
        },
    } = useCustomizeContext();

    const [faqRes, setFaqres] = useState([]);
    const [description, setDescription] = useState("");
    const [question, setQuestion] = useState("");
    const [descriptionmines, setDescriptionmines] = useState("");
    const [questionmines, setQuestionmines] = useState("");
    const [questiondeposit, SetQuestiondeposit] = useState("");
    const [descriptiondeposit, SetDescriptiondeposit] = useState("");
    const [questiondeposit1, SetQuestiondeposit1] = useState("");
    const [descriptiondeposit1, SetDescriptiondeposit1] = useState("");
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        document.body.classList.remove("SideMenuOpen");
        setClassIsActive(false);
    }, []);

    const {
        loader: {
            setLoading,
        },
        languageContext: {
            language, setLanguage,
            changeLanguageRes, setChangeLanguageRes,
        }
    } = useCustomizeContext();

    useEffect(() => {
        userFaq();
    }, [changeLanguageRes]);

    const userFaq = async () => {
        setLoading(true);
        let res = await dispatch(getUserFaq({ type: "user", "language": localStorage.getItem('lang') }));
        setTimeout(() => {
            if (res?.status) {
                setFaqres(res?.data);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 1000);

    }

    return (
        <Fragment>
            <Header />
            <div class="mainbody-content">
                <Sidebar />
                <div class="center-maincnt">
                    <div class="inr-container">
                        <div class="center-inrcnt">

                            <div class="faqpage-maincnt page-centercnt_nd_bg">
                                <div class="">
                                    <section class="faq_sec_one">
                                        <div class="banner-faq">
                                            <h2>{t("Frequently Asked Questions")}</h2>
                                        </div>
                                        <div class="mt-4">
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <div class="ger_aq">
                                                        <h2>{t("General FAQ’s")}</h2>
                                                        <p>{t("Terminology condition")} </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-7">
                                                    <div class="faq_toatl">
                                                        <Accordion>
                                                            {
                                                                faqRes && faqRes?.map((temp, index) =>
                                                                    <AccordionItem key={index} className="card card1">
                                                                        <AccordionItemHeading>
                                                                            <AccordionItemButton >
                                                                                {temp?.question}
                                                                            </AccordionItemButton>
                                                                        </AccordionItemHeading>
                                                                        <AccordionItemPanel>
                                                                            <p dangerouslySetInnerHTML={{ __html: temp?.description }}>
                                                                            </p>
                                                                        </AccordionItemPanel>
                                                                    </AccordionItem>
                                                                )
                                                            }
                                                        </Accordion>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </Fragment>
    );

}

export default Faq;